var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBaseBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 202.69 144.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b826bee5-aee8-4b7c-8690-03c59c51472a{fill:#815aaf;}.ae90ee2c-ca5c-4022-b632-3962dd527b2f{fill:#9e6eca;}.a0e0cb99-b9b7-40bc-ad66-115a901a9a04{isolation:isolate;}.b492de21-42eb-41e3-a300-5d87a3945259{fill:#fff;}.b21f3cfd-91ea-4a7b-bf5e-b390ffe6f250{fill:#c4a4e2;}.bd3dcf25-386c-4864-b148-49a7c31405e3{fill:#8661c5;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a3f83b5f-68ef-41fc-b5bf-6f6fe7292d31",
    "data-name": "CIRCUIT FINAL"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b826bee5-aee8-4b7c-8690-03c59c51472a",
    d: "M148,67.8,114.43,87.31c-7.1,4.12-18.65,4.12-25.8,0L54.85,67.8c-3.6-2.07-5.4-4.8-5.39-7.52L49.4,83.4c0,2.72,1.78,5.45,5.38,7.52l33.79,19.51c7.14,4.13,18.7,4.13,25.8,0l33.56-19.51c3.53-2,5.3-4.73,5.3-7.42l.07-23.12C153.29,63.07,151.53,65.75,148,67.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ae90ee2c-ca5c-4022-b632-3962dd527b2f",
    d: "M147.91,52.86c7.15,4.12,7.19,10.81.09,14.94L114.43,87.31c-7.1,4.12-18.65,4.12-25.8,0L54.85,67.8C47.7,63.68,47.66,57,54.76,52.86L88.33,33.35c7.1-4.13,18.65-4.12,25.8,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "a0e0cb99-b9b7-40bc-ad66-115a901a9a04"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b492de21-42eb-41e3-a300-5d87a3945259",
    d: "M71.21,79.4c4.41,2.55,8,8.74,8,13.82s-3.62,7.14-8,4.59-8-8.75-8-13.84S66.78,76.84,71.21,79.4Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "b21f3cfd-91ea-4a7b-bf5e-b390ffe6f250",
    d: "M71.2,79.4c4.42,2.55,8,8.75,8,13.83s-3.62,7.13-8,4.58-8-8.75-8-13.84S66.78,76.85,71.2,79.4Zm0,17.33c3.9,2.25,7.09.44,7.1-4a15.58,15.58,0,0,0-7.06-12.21c-3.89-2.24-7.08-.43-7.09,4a15.57,15.57,0,0,0,7.05,12.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "bd3dcf25-386c-4864-b148-49a7c31405e3",
    points: "72.06 92.5 73.78 93.49 73.78 94.97 68.55 91.95 68.55 90.47 70.4 91.54 70.41 87.83 68.56 86.76 68.57 85.28 72.08 87.3 72.06 92.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bd3dcf25-386c-4864-b148-49a7c31405e3",
    d: "M71.25,86a1.72,1.72,0,0,1-1-1.48v-.38c0-.51.27-.75,1-.33a1.68,1.68,0,0,1,1,1.49v.37C72.25,86.15,72,86.4,71.25,86Z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaseBackground);
export default __webpack_public_path__ + "static/media/base-background.ddd0859f.svg";
export { ForwardRef as ReactComponent };